import type { NodeDefinition } from '../../../types/node-definition';

const definition: NodeDefinition = {
  type: 'openai',
  name: 'OpenAI',
  category: 'ai',
  description: 'OpenAI GPT models for chat conversations and text generation',
  icon: 'siOpenai',
  iconType: 'simple-icon',
  color: 'green',
  version: '1.2.0',
  
  // Mark as sub-node - only used with AI Agent
  isSubNode: true,
  subNodeConfig: {
    category: 'chatModel',
    requiredFor: ['aiAgent'],
    multipleAllowed: false // Only one chat model per AI Agent
  },
  
  group: ['ai'],
  
  defaults: {
    name: 'OpenAI',
    color: '#10a37f'
  },
  
  subtitle: '={{ $parameter.model }}',
  
  credentials: [
    {
      name: 'openai',
      required: true,
      displayName: 'OpenAI API'
    }
  ],
  
  requestDefaults: {
    baseURL: 'https://api.openai.com/v1',
    headers: {
      'Content-Type': 'application/json'
    }
  },
  
  // Sub-nodes don't have traditional inputs/outputs
  // They are connected via special anchors
  inputs: [],
  outputs: [],
  
  // Anchors define the visual connection points
  anchors: {
    input: [
      {
        type: 'subNode',
        subNodeCategory: 'chatModel',
        label: 'Chat Model',
        multiple: false
      }
    ]
  },
  
  tags: ['ai', 'openai', 'gpt', 'llm', 'chat', 'completion', 'text-generation']
};

export default definition;
